/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Issue_Not_CarryoverInputs */

const en_issue_not_carryover = /** @type {(inputs: Issue_Not_CarryoverInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`the line has a product of its own: nothing to detach`)
};

/**
* | output |
* | --- |
* | "the line has a product of its own: nothing to detach" |
*
* @param {Issue_Not_CarryoverInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const issue_not_carryover = /** @type {((inputs?: Issue_Not_CarryoverInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Issue_Not_CarryoverInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_issue_not_carryover(inputs)
});